import { Component, Input, OnInit } from '@angular/core';
import { ToastService } from '@shared/modules/toast/services/toast.service';

@Component({
  selector: 'app-toast-acknowledgment',
  templateUrl: './toast-acknowledgment.component.html',
  styleUrls: ['./toast-acknowledgment.component.scss']
})
export class ToastAcknowledgmentComponent implements OnInit {
  @Input() public toast$: any;

  constructor(private toastService: ToastService) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {}

  close() {
    this.toastService.removeToast(this.toast$);
  }
}
